/**
 * This file was generated by st-open-api
 */
import {ErrorHandler} from '../interface/i-$-open-api';
import {ITokenQueryParameter} from '../interface/parameter/i-token-query-parameter';
import {ITokenRequest} from '../interface/components/i-token-request';
import {ITokenResponse} from '../interface/components/i-token-response';
import {RequestInterceptor} from '../interface/i-$-open-api';
import {ResponseInterceptor} from '../interface/i-$-open-api';
import {http} from '../function/http';
import {openApi} from '../function/open-api';

export class StsBaseService {

    token = async (queryParameter: ITokenQueryParameter, body: ITokenRequest, interceptor: RequestInterceptor = openApi.requestInterceptor, errorHandler: ErrorHandler = openApi.errorHandler, responseInterceptor: ResponseInterceptor<any> = openApi.responseInterceptor): Promise<ITokenResponse> => {
    
        const queryParam = [
            {name: 'disableCache', value: queryParameter.disableCache},
        ];
    
        const response = await http({
                method: 'POST',
                url: `${openApi.endpointUrl}/sts/v1/token`,
                queryParameter: queryParam,
                header: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            },
            interceptor,
            errorHandler,
            responseInterceptor
        );
        return JSON.parse(response);
    };
    

}
